module.exports = __webpack_public_path__ + "static/media/cross_white.adaa359f.svg";